import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { RepresentativeHttpRepository } from '../../../infrastructure/repositories/representative.http.repository';

export class RepresentativeRepositoryInstruction implements ClassProvider {
  provide = Types.RepresentativeRepository;
  deps = [Types.Settings];
  useClass = RepresentativeHttpRepository;
}
